"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderOrThrowError = exports.getModulesLengthError = exports.getModulesContentError = exports.getModulesContentAndLengthError = void 0;
var _presentationUtils = require("@ori/presentation-utils");
var _EditorialErrorMessage = require("../components/EditorialErrorMessage");
var _jsxRuntime = require("react/jsx-runtime");
const renderOrThrowError = ({
  debug,
  message,
  modulePosition,
  layout
}) => {
  if (!debug) {
    return null;
  }
  if ((0, _presentationUtils.isSSR)()) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_EditorialErrorMessage.EditorialErrorMessage, {
      errorMessage: message,
      modulePosition: modulePosition,
      module: layout
    });
  }
  throw new Error(message);
};
exports.renderOrThrowError = renderOrThrowError;
const getModulesLengthError = ({
  debug,
  modulePosition,
  layout
}) => renderOrThrowError({
  debug,
  message: `${layout} must have at least one module.`,
  modulePosition,
  layout
});
exports.getModulesLengthError = getModulesLengthError;
const getModulesContentError = ({
  debug,
  modulePosition,
  layout
}) => renderOrThrowError({
  debug,
  message: `${layout} must have content.`,
  modulePosition,
  layout
});
exports.getModulesContentError = getModulesContentError;
const getModulesContentAndLengthError = ({
  debug,
  modulePosition,
  layout
}) => renderOrThrowError({
  debug,
  message: `${layout} must have layout specified and have at least one module.`,
  modulePosition,
  layout
});
exports.getModulesContentAndLengthError = getModulesContentAndLengthError;
